import React from "react";
import { ExternalLink } from "lucide-react";
import { addUtm } from "@/lib/utm";
import { trackEvent, reportBuyNavOutcome } from "@/lib/tracking";
import { shouldRewriteOutbound, buildAndroidIntentUrl } from "@/lib/outbound";

// Single outbound storefront button. UTM-stamps the URL, fires `buy_click`,
// schedules a 3s diagnostic to detect FB-IAB-blocked navigation, and on
// Android-in-FB-IAB rewrites the URL to an `intent://` scheme so the
// retailer's native app handles the handoff (or Chrome falls back).
export default function StorefrontButton({
  url,
  label,
  store,
  market,
  titleId,
  slug,
  solid = false,
  campaign,
  comingSoon = false,
}) {
  if (comingSoon || !url) {
    return (
      <span className="btn-pill opacity-60 cursor-default" title="Coming soon">
        {label}
      </span>
    );
  }
  const stampedUrl = addUtm(url, { campaign, content: store });

  return (
    <a
      href={stampedUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`btn-pill ${solid ? "btn-pill-solid" : ""}`}
      data-track="storefront-out"
      data-platform={label}
      data-store={store}
      data-market={market}
      onClick={(e) => {
        const eventProps = {
          title_id: titleId || slug,
          slug,
          store,
          market,
          outbound_url: stampedUrl,
        };
        trackEvent("buy_click", eventProps);
        // FB IAB workaround for Android — rewrite to intent:// so the
        // OS handles the retailer-app handoff instead of FB's webview
        // silently swallowing the click.
        if (shouldRewriteOutbound(store)) {
          e.preventDefault();
          const intentUrl = buildAndroidIntentUrl(stampedUrl, store);
          window.location.href = intentUrl;
        }
        // Diagnostic — fires `buy_click_blocked` 3s later if the user
        // is somehow still on this page (silent IAB failure).
        reportBuyNavOutcome(eventProps);
      }}
    >
      {label}
      <ExternalLink size={13} />
    </a>
  );
}

// Reserved slot for "Buy direct" (Stripe / Shopify) — hidden until enabled.
export function BuyDirectSlot({ enabled = false, onClick, label = "Buy direct" }) {
  if (!enabled) return null;
  return (
    <button onClick={onClick} className="btn-pill btn-pill-solid">
      {label}
    </button>
  );
}
